import React from 'react';
import useLogOut from '../../Hooks/useLogOut';
import HomeIcon from '../../Assets/home_icon.svg';
import sidebarDiscoverIcon from '../../Assets/svgs/sidebarDiscoverIcon.svg';
import sidebarJobsIcon from '../../Assets/svgs/sidebarJobsIcon.svg';
import mockIcon from '../../Assets/svgs/mockICONnew.svg';
import { useNavigate, Link } from 'react-router-dom';
import appLogo from '../../Assets/logo.png';
import useRouteFunctions from '../../Hooks/Routes/useRouteFunctions';
import zepcruitSmallLogo from '../../Assets/svgs/zepcruitSmallLogo.svg';
import Logout from "../../Assets/svgs/logout.svg";

const SideBar = React.forwardRef(({ }, ref) => {
    const { goToDashboard, goToHomePage, goToJobsPage, goToDiscoverPage } = useRouteFunctions();
    const navigate = useNavigate();
    const [loading, error, logoutFunction] = useLogOut();

    const list = [
        { text: "Home", icon: HomeIcon, route: goToDashboard },
        { text: "Jobs", icon: sidebarJobsIcon, route: goToJobsPage },
        { text: "Discover", icon: sidebarDiscoverIcon, route: goToDiscoverPage },
        { text: "Mock", icon: mockIcon, route: () => navigate('/mock') },
    ];

    const currentSection = window.location.pathname?.split('/')?.[1];

    return (
        <div
            ref={ref}
            className='bg-white-bg-color z-[99] fixed bottom-0 right-0 left-0 h-fit lg:h-screen lg:static'
        >
            {/* Desktop Sidebar */}
            <div className="hidden lg:flex h-full group relative transition-all duration-300 w-[4rem] hover:w-[9rem] bg-white shadow-md">                <div className='absolute top-6 left-1/2 transform -translate-x-1/2 group-hover:left-6 group-hover:transform-none '>
                    <Link to={'/'}>
                        <img
                            src={zepcruitSmallLogo}
                            alt="Small Logo"
                            className='w-6 cursor-pointer block group-hover:hidden'
                            onClick={goToHomePage}
                        />
                        <img
                            src={appLogo}
                            alt="Full Logo"
                            className='w-28 cursor-pointer hidden group-hover:block transition-all duration-300'
                            onClick={goToHomePage}
                        />
                    </Link>
                </div>

                {/* Navigation */}
                <div className='flex flex-col justify-between pt-20 pb-6 w-full px-2 h-full'>
                    {/* Nav Items */}
                    <div className='space-y-4'>
                        {list.map((item, index) => {
                            const isActive = '/' + currentSection === item.route.name;
                            return (
                                <div
                                    key={index}
                                    onClick={() => item.route()}
                                    className={`flex items-center gap-3 p-3 rounded-full cursor-pointer transition-all duration-200 hover:bg-primary-color-900 ${isActive ? 'bg-primary-color-900 text-white' : 'text-black'
                                        }`}
                                >
                                    <img src={item.icon} alt={item.text} className='w-6' />
                                    <span className="hidden group-hover:inline text-base font-semibold whitespace-nowrap">
                                        {item.text}
                                    </span>
                                </div>
                            );
                        })}
                    </div>

                    {/* Logout Button at Bottom */}
                    <div
                        onClick={() => logoutFunction()}
                        className="flex items-center gap-3 p-3 rounded-full cursor-pointer transition-all duration-200 hover:bg-red-100"
                    >
                        <img src={Logout} alt="Logout" className="w-6" />
                        <span className="hidden group-hover:inline text-base font-semibold whitespace-nowrap text-red-500">
                            Logout
                        </span>
                    </div>
                </div>
            </div>

            {/* Mobile Navbar */}
            <div className='flex justify-evenly lg:hidden py-2 bg-white'>
                {list.map((item, index) => {
                    const isActive = '/' + currentSection === item.route.name;
                    return (
                        <div
                            key={index}
                            onClick={() => item.route()}
                            className='flex flex-col items-center justify-center gap-1 cursor-pointer'
                        >
                            <div className={`p-2 rounded-full ${isActive ? 'bg-primary-color-900' : ''}`}>
                                <img className='w-6' src={item.icon} alt={item.text} />
                            </div>
                            <span className={`text-xs font-medium ${isActive ? 'text-black' : 'text-gray-500'}`}>
                                {item.text}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
});

export default SideBar;
